<div class="no-access-page">
  <div class="container">
    <div class="icon-section">
      <mat-icon>folder_off</mat-icon>
    </div>

    <h1>No Projects Available</h1>

    <p class="description">
      You don't have access to any projects at the moment. Please contact your administrator to get access to projects.
    </p>

    <div class="actions">
      <button mat-raised-button color="primary" (click)="signOut()">Sign Out</button>
    </div>
  </div>
</div>
